const gerar_melhor_sequencial_de_matricula = {
  path: "/gerar-melhor-sequencial-de-matricula",
  redirect: "/gerar-melhor-sequencial-de-matricula",
  meta: {
    breadCrumb:
      "Planejamento de Matrícula - Gerar Melhor Sequencial de Matrícula",
  },
  children: [
    {
      path: "/gerar-melhor-sequencial-de-matricula",
      name: "gerar-melhor-sequencial-de-matricula",
      component: () =>
        import(
          "@/views/GerarMelhorSequencialDeMatricula/GerarMelhorSequencialDeMatriculaHome.vue"
        ),
    },
  ],
};

export { gerar_melhor_sequencial_de_matricula };
